import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';

import './FreelancersListCellWrapper.css';

const BLOCK = 'freelancers-list-cell-wrapper';

interface FreelancersListCellWrapperProps {
    isLink?: boolean;
}

export class FreelancersListCellWrapper extends React.Component<
    FreelancersListCellWrapperProps
> {
    render() {
        const { children, isLink = false } = this.props;
        return (
            <div
                className={Bem.cls({
                    block: BLOCK,
                    mods: { 'is-link': isLink }
                })}
            >
                {children}
            </div>
        );
    }
}
